import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserRightsEnum } from '@evasys/globals/shared/enums/business/user-rights.enum';
import { AuthGuard } from '@evasys/shared/feature';
import { SystemActivationGuard } from '../../../../libs/evasys/shared/feature/src/lib/system-activation/guards/system-activation.guard';

const routes: Routes = [
	{
		path: '',
		loadChildren: () =>
			import('@evasys/evasys/authentication/feature').then((m) => m.EvasysAuthenticationFeatureModule),
	},
	{
		path: 'subunits',
		loadChildren: () => import('@evasys/evasys/subunit/feature').then((m) => m.EvasysSubunitFeatureModule),
		canActivate: [AuthGuard, SystemActivationGuard],
		data: {
			rights: [UserRightsEnum.ADMINISTRATOR, UserRightsEnum.SUBSECTION_ADMINISTRATOR],
		},
	},
	{
		path: '**',
		redirectTo: '',
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
})
export class AppRoutingModule {}
